<template>
	<div class="dis-fle">
		<div class="flex-1 b-l">
			<div class="model1 bor">
				<div class="dis-fle ali-cen">
					<span class="txt-18">{{ $t('资产总估值') }}</span>
					<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"
						class="svg-class">
						<path
							d="M13 6.5C8.73438 6.5 4.63125 9.20156 3.25 13C4.63125 16.7984 8.73438 19.5 13 19.5C17.2453 19.5 21.3891 16.7984 22.7703 13C21.3688 9.20156 17.2453 6.5 13 6.5ZM13 17.0625C10.7656 17.0625 8.9375 15.2344 8.9375 13C8.9375 10.7656 10.7656 8.9375 13 8.9375C15.2344 8.9375 17.0625 10.7656 17.0625 13C17.0625 15.2344 15.2344 17.0625 13 17.0625ZM15.4375 13C15.4375 14.3406 14.3406 15.4375 13 15.4375C11.6594 15.4375 10.5625 14.3406 10.5625 13C10.5625 11.6594 11.6594 10.5625 13 10.5625C14.3406 10.5625 15.4375 11.6594 15.4375 13Z">
						</path>
					</svg>
				</div>
				<div class="top-info">
					<div class="left-con">
						<span class="balance">${{ data.total_money }}</span>
						<span class="txt-14">{{ data.unit }}</span>
					</div>
					<div class="right-con">
						<div class="operate-btn" @click="$nav.go('/pc/deposit')">
							<div class="svg-container" style="fill: rgb(85, 109, 234);">
								<svg data-v-4afd5caa="" width="12" height="12" viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg" class="svg-class">
									<path data-v-4afd5caa="" id="Vector"
										d="M11.0391 2.24013C11.3569 2.55793 11.4993 2.84687 11.4662 3.10694C11.4331 3.36702 11.2554 3.65829 10.9329 3.98076L10.2403 4.67333C9.92518 4.98847 9.59178 5.32566 9.24011 5.68489C8.88845 6.04412 8.54405 6.3923 8.20693 6.72942L7.40442 7.53193C7.12593 7.81042 6.9326 8.0605 6.82446 8.28214C6.71631 8.50379 6.76805 8.7131 6.97968 8.91007C7.13101 9.06141 7.30705 9.24478 7.50781 9.46019C7.70856 9.6756 7.88839 9.86276 8.04729 10.0217C8.31212 10.2865 8.41086 10.5245 8.34349 10.7356C8.27613 10.9467 8.0455 11.0752 7.6516 11.121C7.25014 11.1593 6.7762 11.2057 6.22981 11.2603C5.68341 11.3149 5.12584 11.3692 4.5571 11.4235C3.98836 11.4777 3.42706 11.532 2.87322 11.5864C2.31937 11.6409 1.8306 11.6908 1.40691 11.7361C1.00545 11.7744 0.721544 11.714 0.555196 11.555C0.388849 11.396 0.321261 11.1269 0.352435 10.7476C0.376042 10.3608 0.411582 9.90532 0.459056 9.38114C0.50653 8.85697 0.55743 8.31424 0.611757 7.75294C0.666084 7.19165 0.716806 6.63774 0.763923 6.09123C0.81104 5.54471 0.853493 5.05582 0.891282 4.62457C0.935924 4.15619 1.06529 3.86415 1.27937 3.74843C1.49345 3.63272 1.73669 3.71106 2.00909 3.98346L2.29284 4.26721C2.39877 4.37314 2.51032 4.48103 2.62749 4.59086C2.74465 4.7007 2.85992 4.80864 2.9733 4.91469C3.08669 5.02075 3.18499 5.11539 3.26823 5.19862C3.46472 5.38046 3.64253 5.44101 3.80164 5.38026C3.96076 5.31951 4.13559 5.19386 4.32614 5.00331C4.53868 4.79077 4.81528 4.51039 5.15595 4.16215C5.49662 3.81391 5.85384 3.45291 6.22761 3.07914C6.60138 2.70537 6.96227 2.3407 7.31027 1.98513C7.65826 1.62957 7.9422 1.34185 8.16206 1.12199C8.25734 1.02671 8.36384 0.935341 8.48158 0.847871C8.59931 0.760401 8.7287 0.7029 8.86973 0.675369C9.01076 0.647837 9.15984 0.657663 9.31695 0.704847C9.47407 0.752031 9.63586 0.858857 9.80233 1.02532C10.0066 1.22962 10.2052 1.42452 10.398 1.61003C10.5909 1.79553 10.8046 2.00556 11.0391 2.24013Z">
									</path>
								</svg>
							</div>
							<span class="name">{{ $t('充值') }}</span>
						</div>
						<div class="operate-btn" @click="$nav.go('/pc/withdrawDeposit')">
							<div class="svg-container" style="fill: rgb(85, 109, 234);">
								<svg data-v-4afd5caa="" width="12" height="12" viewBox="0 0 12 12"
									xmlns="http://www.w3.org/2000/svg" class="svg-class">
									<path data-v-4afd5caa="" id="Vector"
										d="M2.14052 11.1407C2.45832 11.4585 2.74726 11.6008 3.00734 11.5678C3.26741 11.5347 3.55868 11.3569 3.88115 11.0345L4.57372 10.3419C4.88886 10.0267 5.22605 9.69334 5.58528 9.34167C5.94451 8.99001 6.29269 8.64561 6.62981 8.30849L7.43232 7.50598C7.71081 7.22749 7.96089 7.03417 8.18253 6.92602C8.40418 6.81787 8.61349 6.86961 8.81046 7.08124C8.9618 7.23257 9.14517 7.40862 9.36058 7.60937C9.57599 7.81013 9.76315 7.98995 9.92205 8.14885C10.1869 8.41369 10.4249 8.51242 10.636 8.44506C10.8471 8.37769 10.9756 8.14706 11.0214 7.75316C11.0597 7.3517 11.1061 6.87777 11.1607 6.33137C11.2152 5.78497 11.2696 5.2274 11.3238 4.65866C11.3781 4.08992 11.4324 3.52863 11.4868 2.97478C11.5413 2.42093 11.5912 1.93217 11.6365 1.50848C11.6748 1.10701 11.6144 0.823107 11.4554 0.656759C11.2964 0.490411 11.0272 0.422824 10.648 0.453997C10.2612 0.477604 9.80571 0.513144 9.28153 0.560618C8.75736 0.608092 8.21463 0.658992 7.65333 0.71332C7.09204 0.767646 6.53813 0.818368 5.99162 0.865485C5.4451 0.912602 4.95621 0.955055 4.52496 0.992844C4.05658 1.03749 3.76454 1.16685 3.64882 1.38093C3.53311 1.59501 3.61145 1.83825 3.88385 2.11065L4.1676 2.3944C4.27353 2.50034 4.38142 2.61188 4.49125 2.72905C4.60109 2.84621 4.70903 2.96149 4.81509 3.07487C4.92114 3.18825 5.01578 3.28656 5.09901 3.36979C5.28085 3.56628 5.3414 3.74409 5.28065 3.90321C5.2199 4.06232 5.09425 4.23715 4.9037 4.4277C4.69116 4.64024 4.41078 4.91684 4.06254 5.25751C3.7143 5.59818 3.3533 5.9554 2.97953 6.32917C2.60576 6.70294 2.24109 7.06383 1.88553 7.41183C1.52996 7.75983 1.24224 8.04376 1.02238 8.26362C0.927103 8.3589 0.835731 8.4654 0.748262 8.58314C0.660792 8.70088 0.603291 8.83026 0.57576 8.97129C0.548228 9.11232 0.558054 9.2614 0.605237 9.41851C0.652421 9.57563 0.759247 9.73742 0.925714 9.90389C1.13001 10.1082 1.32491 10.3068 1.51042 10.4996C1.69592 10.6924 1.90595 10.9061 2.14052 11.1407Z">
									</path>
									<defs data-v-4afd5caa="">
										<linearGradient data-v-4afd5caa="" id="paint0_linear_5342_33659" x1="11.4359"
											y1="0.63711" x2="1.53644" y2="10.5366" gradientUnits="userSpaceOnUse">
											<stop data-v-4afd5caa="" offset="0.497917" stop-color="#6491E9"></stop>
											<stop data-v-4afd5caa="" offset="1" stop-color="#556DEA"></stop>
										</linearGradient>
									</defs>
								</svg>
							</div>
							<span class="name">{{ $t('提币') }}</span>
						</div>
						<div class="operate-btn">
							<div class="svg-container" style="fill: rgb(255, 255, 255);">
								<svg data-v-4afd5caa="" width="24" height="24" viewBox="0 0 24 24" fill="none"
									xmlns="http://www.w3.org/2000/svg" class="svg-class">
									<path data-v-4afd5caa=""
										d="M15.6365 2.22355C15.3541 2.14258 15.0479 2.22385 14.8434 2.43828L14.8404 2.43742L6.61908 10.8601L6.62208 10.861C6.51553 10.9604 6.43686 11.0874 6.39724 11.2256C6.27578 11.6492 6.52218 12.0937 6.94574 12.2151L10.0218 13.0972L7.81667 20.7873C7.69522 21.2108 7.94162 21.6553 8.36517 21.7768C8.65355 21.8595 8.96441 21.7731 9.17066 21.5526L17.4393 13.0785L17.4371 13.0746C17.5106 12.9884 17.5708 12.8919 17.6044 12.7747C17.7258 12.3512 17.4794 11.9067 17.0559 11.7852L13.9799 10.9032L16.1849 3.21307C16.3064 2.78952 16.06 2.345 15.6365 2.22355Z"
										fill="#ffffff"></path>
								</svg>
							</div>
							<span class="name" @click="$nav.go('/pc/exchange')">{{ $t('闪兑') }}</span>
						</div>
						<div class="operate-btn">
							<span class="name" @click="$emit('goOrderTransfer')">{{ $t('划转') }}</span>
						</div>
					</div>
				</div>

				<div class="chart-title">
					<div class="left-con">{{ $t('资产趋势') }}</div>
					<div class="right-con">
						<div v-for="item in tabList" :key="`${item.id}Tab`" :class="{ active: tabs == item.id }"
							@click="tabs = item.id">{{ item.name }}</div>
					</div>
				</div>

				<div class="chart">
					<LineChart :xData="xData" :yData="yData" />
				</div>
			</div>
			<div class="model2 bor">
				<mode2 :list="accountInfo" @refresh="getdata"></mode2>
			</div>
		</div>
		<div class="right">
			<div class="title">{{ $t('资产动态') }}</div>
			<zcTable :list="walletLog"></zcTable>
			<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
				:total="page.total" @current-change="getdata" />
		</div>
	</div>
</template>

<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import mode2 from './model2.vue';
import zcTable from '../zcTable.vue';
import LineChart from './LineChart.vue';
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		mode2,
		oPage,
		LineChart,
		zcTable
	},
	data() {
		return {
			data: {},
			accountInfo: [],
			walletLog: [],

			page: {
				page: 1,
				limit: 13,
				total: 10,
			},

			tabs: '1',
			// tabList: [
			// 	{
			// 		name: this.$t('24小时'),
			// 		id: '1'
			// 	},
			// 	{
			// 		name: this.$t('7日'),
			// 		id: '2'
			// 	},
			// 	{
			// 		name: this.$t('30日'),
			// 		id: '3'
			// 	},
			// 	{
			// 		name: this.$t('365日'),
			// 		id: '4'
			// 	}],

			xData: [],
			yData: [],
		};
	},
	watch: {
		tabs() {
			this.totalEchart()
		}
	},
	computed: {
		tabList() {
			return [
				{
					name: this.$t('24小时'),
					id: '1'
				},
				{
					name: this.$t('7日'),
					id: '2'
				},
				{
					name: this.$t('30日'),
					id: '3'
				},
				{
					name: this.$t('365日'),
					id: '4'
				}]
		}
	},
	methods: {
		init() {
			this.getdata()
			this.totalEchart()
		},
		getdata() {
			get(apis.userAllMoney, { ...this.page }).then(res => {
				if (res.code != 1) return
				this.data = res.data
				this.accountInfo = res.data.account_info.slice(1)
				this.walletLog = res.data.wallet_log || []
				this.page.total = res.data.total || 10
			})
		},
		//资产走势
		async totalEchart() {
			const res = await get(apis.totalEchart, { time: this.tabs })
			if (res.code == 1) {
				this.xData = res.data.xData
				this.yData = res.data.yData
				return
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.right {
	width: 490px;
	height: 892px;
	overflow-y: auto;
	border-radius: 12px;
	border: 2px solid #2c2c3e;
	padding: 20px 30px;

	.title {
		// padding: 0 30px;
		height: 30px;
		line-height: 30px;
	}
}

.b-l {
	margin-right: 30px;

	.model1 {
		height: 475px;
		margin-bottom: 30px;
		font-size: 18px;

		.chart-title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 40px;

			.right-con {
				display: flex;

				>div {
					padding: 3px 12px;
					text-align: center;
					border-radius: 99px;
					border: 1px solid #84849f;
					background: #1f1f2f;
					margin-left: 6px;
					color: #888;
					cursor: pointer;

					&.active {
						border-color: #fff;
						color: #fff;
					}
				}
			}
		}

		.top-info {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.right-con {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.operate-btn {
					width: 100px;
					height: 40px;
					line-height: 15px;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 99px;
					border: 1px solid #84849f;
					margin-left: 10px;
					background: #000;
					font-size: 16px;
					text-align: center;
					cursor: pointer;

					.name {
						margin-left: 5px;
					}
				}
			}

			.left-con {
				position: relative;
				display: flex;
				align-items: center;

				.balance {
					font-size: 24px;
					margin-right: 10px;
				}
			}
		}
	}

	.model2 {}

	.bor {
		border-radius: 12px;
		border: 2px solid #2c2c3e;
		padding: 20px 30px;
	}
}
</style>